import React, { useState } from 'react';
import {
    Card, CardContent, Typography, Button, Box, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SanitizedHtmlRenderer from './SanitizedHtmlRenderer';

const getHtmlContent = (data) => {
    if (!data) return '';
    if (typeof data === 'string') return data;
    if (data.text) return data.text;
    return '';
};

const getPlainText = (data) => {
    const html = getHtmlContent(data);
    return html.replace(/<[^>]*>?/gm, '');
};

const EndScreen = ({ score, totalQuestions, userAnswers, onRestart }) => {
    const [reviewMode, setReviewMode] = useState(false);
    const percentage = totalQuestions > 0 ? ((score / totalQuestions) * 100).toFixed(2) : 0;

    return (
        <Card>
            <CardContent sx={{ textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom>Quiz Complete!</Typography>
                <Typography variant="h5">Your Score: {score} / {totalQuestions} ({percentage}%)</Typography>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                    <Button variant="contained" onClick={onRestart}>Restart Quiz</Button>
                    <Button variant="outlined" onClick={() => setReviewMode(!reviewMode)}>
                        {reviewMode ? "Hide Review" : "Review Answers"}
                    </Button>
                </Box>
                {reviewMode && (
                    <Box sx={{ mt: 4, textAlign: 'left' }}>
                        {userAnswers.map((result, index) => (
                            <Accordion key={index}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography color={result.isCorrect ? 'success.main' : 'error.main'} sx={{ fontWeight: 'bold' }}>
                                        Question {index + 1}: {result.isCorrect ? 'Correct' : 'Incorrect'}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box>
                                        <Typography variant="h6" component="div" gutterBottom>Question:</Typography>
                                        <SanitizedHtmlRenderer htmlContent={getHtmlContent(result.question)} />

                                        <Typography variant="h6" component="div" sx={{ mt: 2 }} gutterBottom>Your Answer:</Typography>
                                        {result.selectedOption ? (
                                            <Typography color={result.isCorrect ? 'success.main' : 'error.main'}>
                                                {getPlainText(result.selectedOption)}
                                            </Typography>
                                        ) : (
                                            <Typography color="text.secondary">You did not answer this question.</Typography>
                                        )}

                                        {!result.isCorrect && (
                                            <>
                                                <Typography variant="h6" component="div" sx={{ mt: 2 }} gutterBottom>Correct Answer:</Typography>
                                                <Typography color="success.main">
                                                    {getPlainText(result.answer)}
                                                </Typography>
                                            </>
                                        )}

                                        <Typography variant="h6" component="div" sx={{ mt: 2 }} gutterBottom>Explanation:</Typography>
                                        <SanitizedHtmlRenderer htmlContent={getHtmlContent(result.explanation)} />
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default EndScreen;
